import { useEffect, useState } from 'react';

// routing
import Routes from 'routes';

// project imports
import Locales from 'jsx/components/utilities/Locales';
import NavigationScroll from 'jsx/layout/NavigationScroll';
import Snackbar from 'jsx/components/extended/Snackbar';
import Loader from 'jsx/components/utilities/Loader';
import Notistack from 'jsx/components/third-party/Notistack';

import ThemeCustomization from 'themes';
import { dispatch } from 'store';
import { getMenu } from 'store/slices/menu';
import NotificationListener from 'jsx/pages/Notifications/NotificationListener';
import { HelmetProvider } from "react-helmet-async";
import { onMessageListener } from 'config/firebase';
// import PageTracking from 'utils/PageTracking';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';

// ==============================|| APP ||============================== //

const App = () => {
    const [loading, setLoading] = useState(false)

    // PageTracking();

    useEffect(() => {
        dispatch(getMenu()).then(() => {
            setLoading(true);
        });
    }, []);

    onMessageListener()
        .then((payload) => {
            console.log("Foreground Notification:", payload);
            alert(payload.notification.title);
        })
        .catch((err) => console.log("Failed to receive notification:", err));

    if (!loading) return <Loader />;

    function logErrorToServer(errorData) {
        fetch('/log-client-error', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(errorData)
        }).catch(() => {
            // Fail silently
        });
    }

    window.onerror = function (message, source, lineno, colno, error) {
        const errorData = {
            type: 'runtime',
            message,
            source,
            lineno,
            colno,
            stack: error?.stack || null,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
        };
        logErrorToServer(errorData);
    };

    window.onunhandledrejection = function (event) {
        const errorData = {
            type: 'promise',
            message: event.reason?.message || String(event.reason),
            stack: event.reason?.stack || null,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
        };
        logErrorToServer(errorData);
    };



    return (
        <ThemeCustomization>
            <Locales>
                <NavigationScroll>
                    <AuthProvider>
                        <Notistack>
                            <HelmetProvider>
                                {/* Your Routes and Components */}
                                <Routes />
                                <Snackbar />
                                {/* <NotificationListener /> */}
                            </HelmetProvider>
                        </Notistack>
                    </AuthProvider>
                </NavigationScroll>
            </Locales>
        </ThemeCustomization>

    );
};

export default App;
